import deepmerge from 'deepmerge';

import { ThemeColors } from '../../../../tokens/colors/types';
import { BaseDeprecatedColors } from '../../../types';
import derivedED from './ED';

const uniqueBackground = '#FF7E29';
const uniqueForeground = '#333333';

export default (baseColors: ThemeColors): BaseDeprecatedColors => {
  return {
    ...deepmerge(derivedED(baseColors), {
      deprecatedAppBannerColors: '#1C708C',
      appBanner: {
        bg: '#F5F5F5',
        bt: '#27A0A0',
        image: null,
        uniqueBackground,
        uniqueForeground,
      },
      promotional: {
        primary: {
          default: baseColors.primary['90'],
          dark: '#000000',
        },
        secondary: {
          default: baseColors.primary['50'],
          dark: '#6A3A1B',
        },
      },
    }),
    banner: {
      bg: baseColors.neutral[0],
      fg: baseColors.primary['50'],
      gradient: [baseColors.primary['90'], '#000000'],
    },
  };
};
